import { selectAnatomy } from "@ark-ui/react";
import { defineSlotRecipe } from "@pandacss/dev";

export const aromaAccordion = defineSlotRecipe({
  className: "aroma-accordion",
  jsx: ["Accordion", "AccordionRoot", "AccordionItem"],
  slots: selectAnatomy.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "gap.2",
      width: "100%",
    },
    item: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
    },
    trigger: {
      paddingY: "10px",
      paddingX: "padding.3",
      display: "flex",
      alignItems: "center",
      gap: "gap.2",
      borderRadius: "l",
      textStyle: "title.s",
      justifyContent: "space-between",
      color: {
        base: "content.neutral.base.bold",
        _disabled: "content.neutral.base.disable",
      },

      _hover: {
        bg: "background.neutral.base.subtlest-hover",
      },

      _focusWithin: {
        shadow: "effect.focus-ring.brand",
        bg: "background.neutral.base.subtlest",
        border: "none",
        outlineWidth: "m",
        outlineStyle: "solid",
        outlineColor: "border.brand-bold",
        _withinWhiteLabelTheme: {
          outlineColor: "border.brand.brand-brand",
        },
      },
    },
    content: {
      padding: "padding.3",
    },
    indicator: {
      display: "flex",
      gap: "gap.2",
      alignItems: "center",
      _aromaticonChildren: {
        alignSelf: "center",
        fontSize: "88",
      },
    },
  },
  variants: {
    withBorder: {
      true: {
        root: {
          borderWidth: "m",
          borderRadius: "m",
          borderStyle: "solid",
          paddingY: "padding.2",
          borderColor: "border.neutral.subtle",
        },
        item: {
          paddingX: "padding.2",
        },
      },
      false: {},
    },
  },
  defaultVariants: {
    withBorder: false,
  },
});
